import en from './en.json'
import ja from './ja.json'

export default { en, ja }
